import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { RdsapComponent } from './components/rdsap/rdsap.component';
import { SettingsScreenComponent } from './components/settings-screen/settings-screen.component';
import { validParamsGuard } from './../guards/valid-params.guard';
import { CreateReportComponent } from './components/create-report/create-report.component';

const routes: Routes = [
  { path: 'rdsap/settings', component: SettingsScreenComponent },
  { path: 'rdsap/create-report', component: CreateReportComponent },
  { path: 'rdsap/:reportReferenceNumber', component: RdsapComponent, canActivate: [validParamsGuard], data: { requiredParams: ['reportReferenceNumber'] } },
  { path: '', component: WelcomeScreenComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RdSAPRoutingModule { }